<template>
  <div class="card">
    <form>
      <div class="card-header">
        <div class="row social">
          <div class="col-md-12 col-xs-12">
            <button class="btn btn-fill btn-facebook" @click.prevent="entrarComSocial(providers.facebook)">
              <i class="ti-facebook"><span> Crie uma conta grátis com o Facebook</span></i>
            </button>
          </div>
          <div class="col-md-12 col-xs-12">
            <button class="btn btn-fill btn-google" @click.prevent="entrarComSocial(providers.google)">
              <i class="ti-google"><span> Crie uma conta grátis com o Google</span></i>
            </button>
          </div>
        </div>
        <hr class="hr-text" data-content="OU">
      </div>
      <div class="card-content">
        <div class="form-group">
          <label>Nome</label>
          <input type="text"
                 id="nome"
                 name="nome"
                 placeholder="Insira seu nome"
                 v-validate="modelValidations.nome"
                 v-model.lazy="model.nome"
                 class="form-control">
          <small class="text-danger" v-show="nome.invalid">
            {{ getError('nome') }}
          </small>
        </div>
        <div class="form-group">
          <label>Email</label>
          <input type="email"
                 name="email"
                 placeholder="Insira seu e-mail"
                 v-validate="modelValidations.email"
                 v-model="model.email"
                 class="form-control">
          <small class="text-danger" v-show="email.invalid">
            {{ getError('email') }}
          </small>
        </div>
        <div class="form-group">
          <label>Celular</label>
          <input type="tel"
                 name="celular"
                 v-mask="'(##) #####-####'"
                 placeholder="Insira seu celular"
                 v-validate="modelValidations.celular"
                 v-model="model.contato.celular"
                 class="form-control">
          <small class="text-danger" v-show="celular.invalid">
            {{ getError('celular') }}
          </small>
        </div>
        <div class="form-group">
          <label>Senha</label>
          <input type="password"
                 id="senha"
                 name="senha"
                 placeholder="Inserir uma senha"
                 v-validate="modelValidations.password"
                 v-model="model.password"
                 class="form-control">
          <small class="text-danger" v-show="senha.invalid">
            {{ getError('senha') }}
          </small>
        </div>
        <div class="form-group">
          <label>Confirmar senha</label>
          <input type="password"
                 id="confirmar_senha"
                 name="confirmar_senha"
                 placeholder="Repetir a senha"
                 v-validate="modelValidations.confirmPassword"
                 v-model="model.confirmPassword"
                 class="form-control">
          <small class="text-danger" v-show="confirmar_senha.invalid">
            {{ getError('confirmar_senha') }}
          </small>
        </div>
      </div>
      <div class="card-footer text-right">
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info btn-wd btn-register">Crie uma conta grátis</button>
        <div class="row">
          <div class="text-center col-sm-12">
            <input type="checkbox" id="termoCheck" name="termoCheck" value="termoCheck" v-on:click="termoCheckMethod">
            Ao clicar em <strong>"Crie uma conta grátis"</strong>, você concorda com os nossos <a href="/static/termos/termos_de_uso.pdf" target="_blank">Termos de Uso</a> e <a href="/static/termos/termos_de_privacidade.pdf" target="_blank"> Política de Privacidade</a>.
            <br>
            <small class="text-danger" v-show="model.termoCheck">
            Para continuar o seu cadastro é necessário concordar com nossos termos.
          </small>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import { mask } from 'vue-the-mask'
  import Autenticacao from '@/services/Autenticacao'

  export default {
    directives: {
      mask
    },
    computed: {
      ...mapFields(['nome', 'email', 'celular','senha', 'confirmar_senha'])
    },
    data () {
      return {
        providers: Autenticacao.providers,
        model: {
          termoCheck: false,
          nome: '',
          email: '',
          contato: {
            celular: ''
          },
          password: '',
          confirmPassword: ''
        },
        modelValidations: {
          nome: {
            required: true,
            alpha_spaces: true,
          },
          email: {
            required: true,
            email: true
          },
          celular: {
            required: true
          },
          password: {
            required: true,
            min: 8
          },
          confirmPassword: {
            required: true,
            min: 8
          }
        }
      }
    },
    methods: {
      termoCheckMethod() {
        if(document.getElementById("termoCheck").checked) {
          this.model.termoCheck = false
        } else {
          this.model.termoCheck = true
        }
      },
      entrarComSocial (provider) {
        Autenticacao.entrarComSocial(provider)
          .then(result => {
            this.$router.push({
              name: 'dashboard'
            })
          })
          .catch(error => console.error(error))
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        if(!document.getElementById("termoCheck").checked) {
          this.model.termoCheck = true
          return
        }
        this.$validator.validateAll().then(isValid => {
          this.$emit('on-submit', this.model, isValid)
        })
      }
    },
    mounted () {
      document.getElementById('nome').focus()
    }
  }
</script>
<style lang="scss" scoped>
  .btn-google,
  .btn-facebook,
  .btn-sign-in,
  .btn-register {
    width: 100%;
    border-radius: 7px !important;
    margin: 5px 0;
  }

  .card {
    border: none;

    .card-content .form-group {
      margin-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/ValidationForms/RegisterForm.vue